import React, { useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { scrollToElement } from '../../utils/utils';
import { rows, columns } from './constants';
import { useStyles } from './AffiliatedSites.styles';

export default function AffiliatedSites() {
    const classes = useStyles();

    function goToTop() {
        const element = document.getElementById('affiliatedSites');
        if (element) scrollToElement(element);
    }

    useEffect(() => {
        document.title = 'Affiliated Sites » Askimam';
        goToTop();
    }, []);

    return (
        <div id="affiliatedSites" className={classes.body}>
            <h2 className="page-title">Affiliated Sites</h2>
            <h4 className="center">Submit Your Questions</h4>
            <p className="center">Affiliated Sites | Students of Mufti Ebrahim Desai Rahimahullah</p>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ fontWeight: 'bold', fontSize: 15, }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.mufti}>
                                        {columns.map((column) => {
                                            return (
                                                <TableCell key={column.id} align={column.align} classes={{ root: classes.cell }}>
                                                    {row[column.id]}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            <h3 className="page-title">Disclaimer:</h3>
            <p>Above sites are run and independently managed by the students of Mufti Ebrahim Desai Rahimahullah. The views on these sites do not necessarily represent that of Mufti Ebrahim Desai. The websites listed are those that Mufti Sahib was aware of or had approved thereof.</p>
            <p>Enquiries regarding the above may be emailed to <a href="mailto:admin@daruliftaa.net"><span>admin@daruliftaa.net</span></a></p>
            <hr />
            <p>Subscribe to the Darul Iftaa WhatsApp service: https://wa.me/27673474561 by sending us a message and saving the number to receive updates.</p>

        </div>
    );
}
